import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatOption, MatSelect } from '@angular/material';
import { UnderwriterTeamBalancerService } from './uwteambalancer.service';
import { LoanChannelDto, LoanPurposeDto, PipelineLoanDto, TeamBalancerDto, UnderwriterDto, TeamBalancerSubmitDto, UnderwriterTeamBalancerBatchRecordDto } from './uwteambalancer.model';
import { AdalService } from '../shared/azure-authentication/adal.service';

@Component({
    selector: 'app-uwteambalancer',
    templateUrl: './uwteambalancer.component.html',
    styleUrls: ['./uwteambalancer.component.css']
})
export class UnderwriterTeamBalancerComponent implements OnInit {

    @ViewChild('allSelected') private allSelected: MatSelect;
    @ViewChild('allSelectedOption') private allSelectedOption: MatOption;
    public underwriterTeamBalancerForm: FormGroup;
    public loanChannels: LoanChannelDto[];
    public loanPurposes: LoanPurposeDto[];
    public selectedLoans: PipelineLoanDto[] = [];
    public selectedUW:  UnderwriterDto[] = [];
    public isLoading: boolean = false;
    public inputMessage: string = "";
    public balanceSuccessMessage: string = "";
    public balanceErrorMessage: string = "";

    public assignedDateStart: Date;
    public assignedDateEnd: Date;

    public loans: PipelineLoanDto[];
    public underWriters: UnderwriterDto[];

    public teamBalancerDto: TeamBalancerDto = new TeamBalancerDto();

    constructor(private dialog: MatDialog, private fb: FormBuilder,
        private service: UnderwriterTeamBalancerService, private adalService: AdalService ) { }

    ngOnInit() {
        this.underwriterTeamBalancerForm = this.fb.group({
            getLoan: this.fb.group({
                uwAssignmentDateStart: [null, Validators.required],
                uwAssignmentDateEnd: [null, Validators.required],
                loanChannel: [null, Validators.required],
                loanPurpose: [null, Validators.required]
            }),
            balanceLoans: this.fb.group({
                loans: [null, Validators.required],
                underwriters: [null, Validators.required]
            }),

            uwSelection: [null]

        });


        this.service.getLoanChannels().then(
            result => {
                this.loanChannels = JSON.parse(JSON.stringify(result))
            }
        )
            .catch(error => console.log(error));

        this.service.getLoanPurposes().then(
            result => {
                this.loanPurposes = JSON.parse(JSON.stringify(result))
            }
        )
            .catch(error => console.log(error));
    }


    async getLoans() {
        this.resetForm();
        if (!this.underwriterTeamBalancerForm.controls.getLoan.valid) {
            var getLoanFormGroup = this.underwriterTeamBalancerForm.controls.getLoan;

            var assignmentDateStartControl = getLoanFormGroup.get("uwAssignmentDateStart");

            var assignmentDateEndControl = getLoanFormGroup.get("uwAssignmentDateEnd");

            if (assignmentDateStartControl.status.toUpperCase() != "VALID") {
                assignmentDateStartControl.setErrors({ 'required': true });
            }

            if (assignmentDateEndControl.status.toUpperCase() != "VALID") {
                assignmentDateEndControl.setErrors({ 'required': true });
            }

            var loanChannelControl = getLoanFormGroup.get("loanChannel");

            if (loanChannelControl.status.toUpperCase() != "VALID") {
                loanChannelControl.setErrors({ 'required': true });
            }
            return;
        }
        
        else {
            await this.getLoansToBalance();
        }
    }

    async balanceLoans() {
        this.balanceErrorMessage = " ";
        this.balanceSuccessMessage = " ";
        if (this.selectedLoans.length === 0) {
            this.balanceErrorMessage = "No loans selected for balance.";
            return;
        }
        else if (this.selectedUW.length === 0) {
            this.balanceErrorMessage = "No underwriters selected for balance.";
            return;
        }
        else if (this.selectedLoans.length > 200) {
            this.balanceErrorMessage = "Max amount of allowed loans is 200. Please limit your selection to 200 loas.";
            return;
        }

        var allUnderwritersHaveCapacity = true;
        this.selectedUW.forEach((element) => {
            if (element.capacity == null) {
                this.balanceErrorMessage = "Please ensure all underwriters have a selected capacity.";
                allUnderwritersHaveCapacity = false;
                return;
            }
        });
        if (!allUnderwritersHaveCapacity) {
            return;
        }

        if (this.selectedLoans.length <= 50) {
            await this.runLoanBalancer();
        }
        else {
            await this.recordBatchLoans();
        }

        this.isLoading = false;
    }

    async recordBatchLoans() {
        this.isLoading = true;

        var batchRecordDto = new UnderwriterTeamBalancerBatchRecordDto();
        batchRecordDto.selectedUnderwriters = this.selectedUW;
        batchRecordDto.selectedLoans = this.selectedLoans;
        batchRecordDto.submitEmail = this.adalService.userInfo.userName;

        await this.service.recordBatch(batchRecordDto).then(batchSuccess => {
            if (batchSuccess) {
                var successMessage = "Underwriter Team Balancer batch successfully added to the queue. You will get an email upon completion.";
                console.log(successMessage);
                this.balanceSuccessMessage = successMessage;
            }
            else {
                var errorMessage = "There was an error when adding your Underwriter Team Balancer batch to the queue. Please try again."
                console.log(errorMessage);
                this.balanceErrorMessage = errorMessage;
            }
        }).catch(error => {
            console.log(error);
            this.isLoading = false;
        });

        this.isLoading = false;
    }

    async runLoanBalancer() {
        this.isLoading = true;
        var teamBalancerSubmit = new TeamBalancerSubmitDto();
        teamBalancerSubmit.selectedUnderwriters = this.selectedUW;

        var successfulLoans: PipelineLoanDto[] = [];
        var failedLoans: PipelineLoanDto[] = [];

        for (const loan of this.selectedLoans) {
            teamBalancerSubmit.selectedLoan = loan;

            await this.service.balanceLoans(teamBalancerSubmit).then(underwriterDto => {
                console.log("Balancing loan " + loan.loanGuid)
                if (underwriterDto === null) {
                    failedLoans.push(loan);
                }
                else {
                    console.log(underwriterDto.name);
                    successfulLoans.push(loan);

                    let underwriterIndex = teamBalancerSubmit.selectedUnderwriters.findIndex(u => u.id == underwriterDto.id);
                    var newCapacity = Number(underwriterDto.capacity) - 1;
                    if (newCapacity > 0) {
                        underwriterDto.capacity = newCapacity.toString();
                        teamBalancerSubmit.selectedUnderwriters[underwriterIndex] = underwriterDto;
                    }
                    else {
                        teamBalancerSubmit.selectedUnderwriters.splice(underwriterIndex, 1);
                    }
                }
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
            if (failedLoans.length > 0) {
                var failedItems = "";
                for (const x of failedLoans) {
                    failedItems = failedItems + ", " + x.fields["Fields.364"];
                }
                var fmessage = failedItems.slice(2)
                this.balanceErrorMessage = "Loans ( " + fmessage + " ) failed to be balanced.";
            }
            if (successfulLoans.length > 0) {
                var succeededItems = "";
                for (const y of successfulLoans) {
                    succeededItems = succeededItems + ", " + y.fields["Fields.364"]
                }
                var smessage = succeededItems.slice(2)
                this.balanceSuccessMessage = "Loans ( " + smessage + " ) were successfully balanced.";
            }

        }

        this.isLoading = false;
    }

    async getLoansToBalance() {
        this.getUnderwriters();

        this.assignedDateStart = new Date(this.underwriterTeamBalancerForm.value.getLoan.uwAssignmentDateStart.getFullYear(),
            this.underwriterTeamBalancerForm.value.getLoan.uwAssignmentDateStart.getMonth(),
            this.underwriterTeamBalancerForm.value.getLoan.uwAssignmentDateStart.getDate());

        this.assignedDateEnd = new Date(this.underwriterTeamBalancerForm.value.getLoan.uwAssignmentDateEnd.getFullYear(),
            this.underwriterTeamBalancerForm.value.getLoan.uwAssignmentDateEnd.getMonth(),
            this.underwriterTeamBalancerForm.value.getLoan.uwAssignmentDateEnd.getDate());

        this.isLoading = true;
        this.inputMessage = "Fetching loans, please wait...";

        var loanChannel = new LoanChannelDto;
        var loanPurpose = new LoanChannelDto;

        loanChannel = this.underwriterTeamBalancerForm.value.getLoan.loanChannel;
        loanPurpose = this.underwriterTeamBalancerForm.value.getLoan.loanPurpose;
        this.teamBalancerDto.PersonaName = "Underwriter";
        this.teamBalancerDto.StartDate = this.assignedDateStart;
        this.teamBalancerDto.EndDate = this.assignedDateEnd;
        this.teamBalancerDto.LoanChannelId = loanChannel.id;
        this.teamBalancerDto.loanPurposeName = loanPurpose.name;

        this.service.getLoansToBalance(this.teamBalancerDto).then(loans => {
            this.isLoading = false;
            this.inputMessage = "";
            if (loans != null && loans.length > 0) {
                this.loans = loans;
                this.underwriterTeamBalancerForm.controls["uwSelection"].setErrors(null);
                this.underwriterTeamBalancerForm.controls["loans"].setErrors(null);
            } else {
                this.loans = [];
                var message = "Loans are not available for the specified  selection criteria, modify selection criteria to fetch loans."
                var dialogData = [{ "message": message, "LoanList": null }];
            }

        }).catch(error => {
            console.log(error);
            this.isLoading = false;
        });
    }

    async getUnderwriters() {
        this.service.getUnderwriters().then(result => {
            this.underWriters = JSON.parse(JSON.stringify(result))

            if (this.underWriters == null || this.underWriters.length <= 0) {
                this.underWriters = [];
                var message = "Underwriters are not available for the specified  selection criteria, modify selection criteria to fetch Underwriters."
                var dialogData = [{ "message": message, "LoanList": null }];
            }
        }).catch(error => {
            console.log(error);
            this.isLoading = false;
        });
    }

    onCapacityClick(event) {
        event.stopPropagation();
    }

    onTextChange(event) {
        event.stopPropagation();
        var usercapacity = (<HTMLInputElement>document.getElementById(event.srcElement.id)).value;
        if (usercapacity == "") {
            (<HTMLInputElement>document.getElementById(event.srcElement.id)).value = "";
            usercapacity = "";
        }

        try {
            if (parseInt(usercapacity) < 1) {
                (<HTMLInputElement>document.getElementById(event.srcElement.id)).value = "";
                usercapacity = "";
            }
        } catch (err) {
            (<HTMLInputElement>document.getElementById(event.srcElement.id)).value = "";
            usercapacity = "";
        }
        this.selectedUW.filter(function (e) {
            if (e.id == event.srcElement.id) {
                e.capacity = usercapacity;
            }
        });
    }

    onUWSelectionChange(event) {
        if (event.value.length > 0) {
            event.value.forEach(val => {
                if (!this.selectedUW.includes(val)) {
                    var usercapacity = (<HTMLInputElement>document.getElementById(val.id)).value;
                    val.capacity = (usercapacity == "" ? null : usercapacity);
                    this.selectedUW.push(val);
                }
            })
            let tempUsers = [...this.selectedUW];
            tempUsers.forEach((val, index) => {
                if (!event.value.includes(val)) {
                    this.selectedUW.splice(index, 1);
                    (<HTMLInputElement>document.getElementById(val.id)).value = "";
                }
            })
        }
        else {
            this.selectedUW.forEach(uw => {
                (<HTMLInputElement>document.getElementById(uw.id)).value = "";
            })
            this.selectedUW = [];
        }
    }

    onLoanSelectionChange(event) {
        this.selectedLoans.length = 0;

        const isSelectAll: boolean = this.allSelected.options
            .filter((item: MatOption) => item.value === 0)
            .map((item: MatOption) => item.selected)[0];

        this.allSelected.options.forEach((item: MatOption) => {
            if (item.selected) {
                this.selectedLoans.push(item.value);
            }
        });

        if (isSelectAll) {
            this.selectedLoans.splice(0, 1);
        }
    }

    toggleAllSelection() {
        this.selectedLoans.length = 0;
        if (this.allSelectedOption.selected) {
            this.allSelected.options.forEach((item: MatOption) => item.select());

            this.loans.forEach((val) => {
                this.selectedLoans.push(val);
            });
        } else {
            this.allSelected.options.forEach((item: MatOption) => item.deselect());
            this.allSelected.writeValue(null);
        }

        console.log(this.selectedLoans.length);
    }

    private async resetForm() {
        this.selectedLoans = [];
        this.selectedUW = [];
        this.loans = [];
        this.underWriters = [];
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/uw-team-balancer/uwteambalancer.component.ts